import { z } from 'zod';
export const ApiResponseSchema = (dataSchema) => z.object({
    success: z.boolean(),
    data: dataSchema.optional(),
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }).optional(),
    meta: z.object({
        timestamp: z.string().datetime(),
        requestId: z.string().uuid(),
    }).optional(),
});
export const ApiErrorSchema = z.object({
    success: z.literal(false),
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }),
    meta: z.object({
        timestamp: z.string().datetime(),
        requestId: z.string().uuid(),
    }),
});
export const HealthCheckSchema = z.object({
    status: z.enum(['healthy', 'degraded', 'unhealthy']),
    version: z.string(),
    uptime: z.number(),
    database: z.enum(['connected', 'disconnected']),
    redis: z.enum(['connected', 'disconnected']).optional(),
});
export const WebSocketMessageSchema = z.object({
    type: z.string(),
    payload: z.unknown(),
    timestamp: z.string().datetime(),
});
